import { API } from 'constants/api';
import { searchParamsNames } from 'constants/searchParamsNames';

/** Получить ссылку на запись конференции */
export function getRecordLink(rawLink: string) {
    const link = new URL(rawLink);
    const searchParams = new URLSearchParams(link.search);

    // добавляем необходимые для vox параметры в ссылку
    [
        { name: searchParamsNames.voxAccountId, value: API.VOX_ACCOUNT_ID },
        { name: searchParamsNames.voxApiKey, value: API.VOX_API_KEY },
    ].forEach(({ name, value }) => {
        searchParams.set(name, `${value}`);
    });

    link.search = `${searchParams}`;

    return `${link}`;
}
